import React from 'react';
import { IPowerBoxProps } from '../PowerBox/PowerBox';
import { GetLanguage, formatAbsNumberMW } from '../Utility';
import { IStrings, strings } from '../../loc/mystrings';
import GasStorageLabel from './GasStorageLabel';
const locals:IStrings = strings(GetLanguage());

export interface IGasStorageLabelsState {
    data: any[];    
}



class GasStorageLabels extends React.Component<IPowerBoxProps, IGasStorageLabelsState> {    
    constructor(props: IPowerBoxProps,) {
        super(props);        
        this.state = { data : []};
    }   

    componentDidUpdate(prevprops:IPowerBoxProps) {        
        if(this.props && this.props.data && prevprops.data !== this.props.data){
            this.updateLabels();           
        }    
    }
    
        
    componentDidMount() {
        if(this.props && this.props.data){
            this.updateLabels();           
        }                
    }
 
    private updateLabels(){
        let dataArray:any[]=[];
        let vLabel:string;        
        let exportString = locals.Export;
        let importString = locals.Import;
                
        let data = this.props.data;        
        console.log(data);
        let value = data.kWhFromTyra;        
        value<0?vLabel= exportString + ": ":vLabel=importString + ": ";     
        dataArray.push({label: locals.Import, value:formatAbsNumberMW(value) + ' MW', ekstraLabel:null, ekstraLabelValue:null,
        xpos:'30', ypos:'185',directionLabel:vLabel });
                                          
        value = data.KWhToOrFromGermany;         
        value<0?vLabel= exportString + ": ":vLabel=importString + ": ";     
        dataArray.push({label: locals.Import, value:formatAbsNumberMW(value) + ' MW', ekstraLabel:null, ekstraLabelValue:null,
        xpos:'100', ypos:'250',directionLabel:vLabel});
                                      
        value = data.KWhToSweden;        
        value<0?vLabel= exportString + ": ":vLabel=importString + ": ";     
        dataArray.push({label: locals.Export, value:formatAbsNumberMW(value) +' MW', ekstraLabel:null, ekstraLabelValue:null,
        xpos:'290', ypos:'150',directionLabel:vLabel});

        value = data.KWhToPoland;
        value<0?vLabel= exportString + ": ":vLabel=importString + ": ";     
        dataArray.push({label: locals.Export, value:formatAbsNumberMW(value) +' MW', ekstraLabel:null, ekstraLabelValue:null,
        xpos:'270', ypos:'225',directionLabel:vLabel});
                
        this.setState({
            data: dataArray
        });          
    }

    render() {
        let key:number = 1;
        return (      
            this.state && this.state.data.map((itm) => {
             return <GasStorageLabel key={key++} flow={itm.value} label={itm.label} xpos={itm.xpos} ypos={itm.ypos} 
             directionLabel={itm.directionLabel} ekstraLabel={itm.ekstraLabel} ekstraLabelValue={itm.ekstraLabelValue} />
            })
            
        );
    }
}

export default GasStorageLabels;   

